import React from 'react';
import './MainContent.css';
import Overview from '../Overview/Overview';
import OutbreakAlerts from '../OutbreakAlerts/OutbreakAlerts'
import Subscribe from '../Subscribe/Subscribe'
import ContactUs from '../ContactUs/ContactUs';
import MediaAndResources from '../MediaAndResources/MediaAndResources';
const MainContent = () => (
  <div className="main-content">
    <Overview id="overview"/>
    <OutbreakAlerts id="outbreak-alerts"/>
    <Subscribe />
    <MediaAndResources/>
    <ContactUs id="contact-form-container"/>
  </div>
);

export default MainContent;
